import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "review-paper"
};
import { ref, onMounted } from 'vue';
import { queryString } from '@/util/util';
import { getStore } from '@/util/store';
import IframeContainer from '@/components/IframeContainer/index.vue';
export default {
  __name: 'index',
  setup: function setup(__props) {
    // 丽升阅卷
    var liUrl = ref('');

    // 生成对接链接
    var generateUrl = function generateUrl() {
      var accessToken = getStore({
        name: 'access_token'
      }); // 获取accessToken
      var LSUrl = 'https://exam.zhixuehuijiao.cn/sso/sd271';
      var qs = {
        token: accessToken,
        target: 'zj'
      };
      liUrl.value = LSUrl + queryString(qs);
      console.log(liUrl.value);
    };
    onMounted(function () {
      generateUrl();
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(IframeContainer, {
        src: liUrl.value
      }, null, 8, ["src"])]);
    };
  }
};